import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '../stores/authStore'
import { jwtDecode } from 'jwt-decode'
import { useRouterStateStore } from '../stores/routerState';

import Home from '../components/HomePage.vue'
import Login from '../components/LoginPage.vue'
import AdminDashboard from '../components/AdminDashboard.vue'
import UserDashboard from '../components/UserDashboard.vue'
import ForgotPassword from '@/components/ForgotPassword.vue'
import AboutMe from '@/components/AboutMe.vue'
import DashboardNav from '@/components/DashboardNav.vue'
import ProductList from '@/components/ProductList.vue'
import UserList from '@/components/UserList.vue'
import UserEdit from '@/components/UserEdit.vue'
import InvoiceList from '@/components/InvoiceList.vue'
import UpdateCompanyInfo from '@/components/UpdateCompanyInfo.vue'
import ContactUs from '@/components/ContactUs.vue'
import ServicesPage from '@/components/ServicesPage.vue'
import RevenueDashboard from '@/components/RevenueDashboard.vue';

const routes: Array<RouteRecordRaw> = [
  { path: '/contact-us', component: ContactUs },
  { path: '/services', component: ServicesPage },
  { path: '/', component: DashboardNav },
  { path: '/login', component: Login },

  { path: '/forgot-password', component: ForgotPassword },
  {
    path: '/admin',
    component: AdminDashboard,
    meta: { requiresAdmin: true },
    children: [
      { path: '', component: RevenueDashboard },
      { path: 'product-list', component: ProductList },
      { path: 'user-list', component: UserList },
      { path: 'update-company-info', component: UpdateCompanyInfo },
      { path: 'revenue-dashboard', component: RevenueDashboard },
      { path: 'invoice-list/:status', component: InvoiceList },
      { path: 'about-me', component: AboutMe },
    ],
  },
  {
    path: '/user',
    component: UserDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/about-me',
    component: AboutMe,
    meta: { requiresAuth: true },
  },
  {
    path: '/dashboard',
    component: DashboardNav,
    meta: { requiresAuth: true },
  },
  {
    path: '/user-edit',
    component: UserEdit,
    meta: { requiresAuth: true },
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/login',  // Redirect to login if route is not found
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
})

let previousRoute: any = null;
// Save the current route to the store
router.afterEach((to) => {
  const routerStateStore = useRouterStateStore();
  if (to.fullPath !== previousRoute) {
    routerStateStore.setLastRoute(to.fullPath);  // Save route if it's different
    previousRoute = to.fullPath;  // Update the previous route
  }
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()

  // If the route requires authentication and the user is not logged in
  if (to.meta.requiresAuth && (!authStore.isAuthenticated || !isTokenValid(authStore.getToken))) {
    authStore.logout()
    next('/login')
  }
  // If the route requires an admin role and the user is not an admin
  else if (to.meta.requiresAdmin && (authStore.getRole !== 'Admin' || !isTokenValid(authStore.getToken))) {
    authStore.logout()
    next('/login')
  } else {
    next() // Proceed to the route
  }
})




const isTokenValid = (token: any): boolean => {
  try {
    const decodedToken = jwtDecode(token) as { exp: number };
    const currentTime = Date.now() / 1000; // Current time in seconds

    // Check if token is expired
    return decodedToken.exp > currentTime;
  } catch (error) {
    return false;
  }
};

export default router
